<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(businessNo)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.businessNo)">{{ data.item.businessNo }}</div>
      </template>

      <template v-slot:cell(businessDate)="data">
        {{ formatDate(data.item.businessDate) }}
      </template>

      <template v-slot:cell(amount)="data">
        {{ formatAmount(data.item.amount) }}
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ApmsRegContractSettlementBusinessDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '55px'},
        {key: 'businessNo', label: '单据号/主题', width: '260px'},
        {key: 'businessDate', label: '业务发生日期', width: '140px'},
        {key: 'amount', label: '金额（元）', width: '130px'},
      ],
      items: [],
    }
  },
  created() {
    const data = this.$route.query.data
    if (data) {
      this.items = JSON.parse(data)
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    formatAmount(value) {
      const num = Number(value)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    formatDate(value) {
      if (!value) return ''
      const str = String(value)
      if (str.length >= 10) return str.slice(0, 10)
      return str
    },
    showDetail(content) {
      if (!content) {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
  }
}
</script>

<style scoped>
</style>
